import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const FileIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5003 2V5C12.5003 5.55228 12.948 6 13.5003 6H16.5003M15.0003 3.5C14.5552 3.10178 14.0934 2.62948 13.8019 2.32273C13.6078 2.11861 13.3398 2 13.0582 2H5.50008C4.39551 2 3.50008 2.89542 3.50008 3.99999L3.5 15.9999C3.49999 17.1045 4.39542 18 5.49999 18L14.5 18C15.6046 18 16.5 17.1046 16.5 16L16.5003 5.39819C16.5003 5.14249 16.4028 4.8967 16.2253 4.71261C15.8971 4.3722 15.3491 3.8121 15.0003 3.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

FileIcon.displayName = 'FileIcon';
